import { render } from "./Roas.vue?vue&type=template&id=1a40f59c&scoped=true"
import script from "./Roas.vue?vue&type=script&lang=js"
export * from "./Roas.vue?vue&type=script&lang=js"

import "./Roas.vue?vue&type=style&index=0&id=1a40f59c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a40f59c"]])

export default __exports__